import QuizMainContent from "./QuizMainContent"
import useHandlePopstate from "../../hooks/QuizPage/useHandlePopstate"

const QuizMain = () => {
  useHandlePopstate()

  return (
    <>
      <QuizMainContent />
    </>
  )
}

export default QuizMain
